import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { IconArrowNarrowRight, IconArrowNarrowLeft } from "@tabler/icons-react";
import Header from "../components/header";
import Seo from "../components/seo";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { GatsbyImage } from "gatsby-plugin-image";

export default function PostTemplate({ data }) {
  const { content, title, date, featuredImage } = data.wpPost;
  const { introduction, subtitle } = data.wpPost.extraEntriesFields;

  console.log(data);

  function translateDate(dateStr) {
    var dateObj = new Date(dateStr);
    var months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var monthName = months[dateObj.getMonth()];
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    return monthName + " " + day + ", " + year;
  }

  React.useEffect(() => {
    const contentElement = document.getElementById("content-blog");
    if (!contentElement) return;

    // Scroll horizontal
    const smoothScroll = (e) => {
      contentElement.scrollLeft += e.deltaY * 0.4;
    };
    contentElement.addEventListener("wheel", smoothScroll);

    // Función para esperar a que gtag esté disponible
    const waitForGtag = (callback, retries = 10) => {
      if (typeof window.gtag === "function") {
        callback();
      } else if (retries > 0) {
        setTimeout(() => waitForGtag(callback, retries - 1), 300);
      } else {
        console.warn("gtag no está disponible tras múltiples intentos.");
      }
    };

    const observer = new MutationObserver(() => {
      const trackableButton = contentElement.querySelector(".buttonBlog");

      if (trackableButton) {
        const handleClick = () => {
          waitForGtag(() => {
            window.gtag("event", "boton_catalogo_2025_click", {
              event_category: "Catálogo",
              event_label: "Botón Catálogo 2025",
              value: 1,
            });
            console.log("✅ Evento GA enviado: boton_catalogo_2025_click");
          });
        };

        trackableButton.addEventListener("click", handleClick);
        observer.disconnect();
      }
    });

    observer.observe(contentElement, {
      childList: true,
      subtree: true,
    });

    // Limpieza
    return () => {
      contentElement.removeEventListener("wheel", smoothScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="relative overflow-hidden w-[100vw]">
      <Header />
      <main
        // pt-[80px] px-8 w-[100vw] h-[100vh] transition-translate duration-100 ease-in-out overflow-x-auto overflow-y-hidden
        className="flex items-center flex-row pt-24 lg:pt-[80px] lg:px-8 h-[100dvh]"
        // id="content-blog"
      >
        <section className="flex flex-row max-w-screen-2xl mx-auto items-center gap-[5vw]">
          <div className="w-1/2 hidden lg:block">
            <h5 className="font-caslon text-xl sm:text-2xl md:text-3xl">
              {translateDate(date)}
            </h5>
            <h1 className="text-3xl lg:text-7xl uppercase my-4 leading-none">
              {title}
            </h1>
            <h3 className="mb-4 text-xl sm:text-2xl md:text-3xl">{subtitle}</h3>
            <p className="text-base w-full">{introduction}</p>

            {/* NAVIGATION INCOMPLETE */}
            {/* <div className="w-full flex flex-row justify-between mt-6">
                  <a className="flex flex-row gap-4 items-center">
                    <IconArrowNarrowLeft
                      size={30}
                      stroke={0.75}
                      className={`transition-all ease-in-out duration-100 mt-1`}
                    />
                    <span className="bold uppercase text-lg">Previous Article</span>

                  </a>
                  <a className="flex flex-row gap-4 items-center">
                    <span className="bold uppercase text-lg">Next Article</span>
                    <IconArrowNarrowRight
                      size={30}
                      stroke={0.75}
                      className={`transition-all ease-in-out duration-100 mt-1`}
                    />
                  </a>
                </div> */}
          </div>

          <div className="relative overflow-visible">
            <div className="blog-gradients absolute w-[200%] h-[10%] left-[-100px] top-[-5%] bg-cream blur-lg z-40"></div>
            <section
              className="w-full px-4 pt-20 lg:pt-0 max-h-[85vh] lg:max-h-[80vh] overflow-scroll"
              style={{ maxWidth: "800px" }}
            >
              <div className="block lg:hidden ">
                <GatsbyImage
                  image={featuredImage.node.gatsbyImage}
                  alt={featuredImage.node.altText}
                  className="w-full h-auto blog-cover-image"
                />
                <h5 className="font-caslon text-xl sm:text-2xl md:text-3xl mt-4">
                  {translateDate(date)}
                </h5>
                <h1 className="text-3xl lg:text-7xl uppercase my-2 md:my-4 leading-none">
                  {title}
                </h1>
                <h3 className="mb-4 bold text-xl md:text-3xl">{subtitle}</h3>
                <p className="text-base w-full">{introduction}</p>
                <hr className="my-8" />
              </div>

              <div
                className="blog-rich-content"
                dangerouslySetInnerHTML={{ __html: content }}
                style={{ lineHeight: "40px" }}
              ></div>
            </section>
            <div className=" blog-gradients absolute w-[200%] h-[10%] left-[-100px] -bottom-[200px] md:bottom-[-5%] bg-cream blur-lg z-40"></div>
            <DotLottieReact
              className="w-[70px] absolute bottom-10 lg:bottom-0 left-1/2 -translate-x-1/2 z-50"
              src="https://lottie.host/cca5e991-ff27-4935-bfd2-c03d54de67ec/HvGCotvIKJ.lottie"
              loop
              autoplay
            />
          </div>
        </section>
      </main>
    </div>
  );
}

export function Head({ data }) {
  const {
    wpPost: { seo },
  } = data;

  return (
    <Seo
      title={seo.title}
      description={seo.metaDesc}
      url={data.site.siteMetadata.siteUrl + "/post/" + data.wpPost.slug}
    />
  );
}

export const query = graphql`
  query Post($slug: String) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    wpPost(slug: { eq: $slug }) {
      content
      excerpt
      slug
      title
      date
      featuredImage {
        node {
          gatsbyImage(width: 600)
          altText
        }
      }

      previous {
        title
      }

      seo {
        title
        metaDesc
        canonical
      }
      extraEntriesFields {
        subtitle
        introduction
      }
    }
  }
`;
